import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useDeleteExamGroup = () => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { message } = App.useApp();

    const deleteExamGroup = async (id: string) => {
        try {
            await axios.delete(`/api/examgroup/${id}`);
        } catch (error) {
            throw new Error(t("messages.error.examGroupDelete"));
        }
    }

    return useMutation({
        mutationFn: deleteExamGroup,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["examGroups"] });
            queryClient.invalidateQueries({ queryKey: ["examQuestionSummary"] });
            message.success(t("messages.success.deleteExamGroup"));
        },
    });
}